import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { AccuracyWeaponCategories, MatchRoundAccuracyStatsCategories } from '../../../../../helpers';
import { IMatchFinalBoxScoreDto } from '../../../../../WorldDoomLeague';
import MatchOverallWeaponsAccuracyTabs from './MatchOverallWeaponsAccuracyTabs';
import MatchOverallWeaponsAccuracyTabsView from './MatchOverallWeaponsAccuracyTabsView';

interface MatchOverallWeaponsAccuracyCategoryTabsViewProps {
    category: AccuracyWeaponCategories;
    categoryObject: MatchRoundAccuracyStatsCategories;
    activeWeapon: string;
    setActiveWeapon: React.Dispatch<React.SetStateAction<string>>;
    finalBoxScore: IMatchFinalBoxScoreDto
};

const MatchRoundWeaponsAccuracyCategoryTabsView = (props: MatchOverallWeaponsAccuracyCategoryTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.category}>
                <TabPane tabId={AccuracyWeaponCategories.Accuracy}>
                    <MatchOverallWeaponsAccuracyTabs activeWeapon={props.activeWeapon} setActiveWeapon={props.setActiveWeapon} category={props.categoryObject} />
                    <MatchOverallWeaponsAccuracyTabsView activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} finalBoxScore={props.finalBoxScore} />
                </TabPane>
                <TabPane tabId={AccuracyWeaponCategories.AccuracyWithFlag}>
                    <MatchOverallWeaponsAccuracyTabs activeWeapon={props.activeWeapon} setActiveWeapon={props.setActiveWeapon} category={props.categoryObject} />
                    <MatchOverallWeaponsAccuracyTabsView activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} finalBoxScore={props.finalBoxScore} />
                </TabPane>
            </TabContent>
        </React.Fragment>);
};

export default MatchRoundWeaponsAccuracyCategoryTabsView;